import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { defineMessages } from 'react-intl';

import CodeIcon from '@/material-icons/400-24px/code.svg?react';
import { injectIntl } from '@/mastodon/components/intl';

import { IconButton } from '../../../components/icon_button';

const messages = defineMessages({
  markdown_on: { id: 'compose_form.markdown.on', defaultMessage: 'Write in Markdown' },
  markdown_off: { id: 'compose_form.markdown.off', defaultMessage: 'Switch to plain text' },
});

const iconStyle = {
  height: null,
  lineHeight: '27px',
};

class MarkdownButton extends PureComponent {

  static propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  handleClick = () => {
    this.props.onClick();
  };

  render () {
    const { intl, active, disabled } = this.props;

    return (
      <div className='compose-form__poll-button'>
        <IconButton
          icon='code'
          iconComponent={CodeIcon}
          title={intl.formatMessage(active ? messages.markdown_off : messages.markdown_on)}
          disabled={disabled}
          onClick={this.handleClick}
          className={`compose-form__poll-button-icon ${active ? 'active' : ''}`}
          size={18}
          inverted
          style={iconStyle}
        />
      </div>
    );
  }

}

export default injectIntl(MarkdownButton);
